import styled from "styled-components";
import EmployeesWrapper from "../../layout/EmployeesWrapper";



const Payroll = () => {
      return (
            <EmployeesWrapper
                  title={'Payroll'}
            >
                  <StyledPayroll>

                  </StyledPayroll>
            </EmployeesWrapper>
      );
};

export default Payroll;


const StyledPayroll = styled.section`
      

`;